import {
  DIVISION_IS_FETCHING,
  DIVISION_LIST,
  DIVISION_TABLE,
  DIVISION_CREATE,
  DIVISION_UPDATE_BY_ID,
  DIVISION_DELETE_BY_ID
} from '../types'

const initialState = {
  isFetching: true,
  list: [],
  table: {
    searchString: '',
    keys: [],
    rows: []
  }
}

export default function (state = initialState, action) {
  switch (action.type) {
    case DIVISION_IS_FETCHING:
      return {
        ...state,
        isFetching: action.payload
      }

    case DIVISION_LIST:
      return {
        ...state,
        list: action.payload
      }

    case DIVISION_TABLE:
      return {
        ...state,
        table: {
          ...state.table,
          ...action.payload
        }
      }

    case DIVISION_CREATE:
      return {
        ...state,
        list: [
          ...state.list,
          action.payload
        ]
      }

    case DIVISION_UPDATE_BY_ID:
      return {
        ...state,
        list: state.list.map(division => division.id === action.payload.id ? action.payload : division)
      }

    case DIVISION_DELETE_BY_ID:
      return {
        ...state,
        list: [
          ...state.list.filter(division => division.id !== action.payload.id)
        ]
      }

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/store/reducers/division.js